import 'jquery-mask-plugin';

function PrepopulatedInput (selector) {
  this.$wrapper = $(selector);
  this.$input = this.$wrapper.find('input, select');
  this.$editForm = this.$wrapper.find('.form-prepopulated');
  this.$prepopulatedText = this.$wrapper.find('.prepopulated');
}

PrepopulatedInput.prototype.init = function () {
  this.addListeners();
  this.addDateMask();
};

PrepopulatedInput.prototype.addListeners = function () {
  var self = this;

  this.$wrapper.find('.edit-prepopulated').click(function (e) {
    e.preventDefault();
    self.showEditForm();
  });

  this.$wrapper.find('.cancel-edit-prepopulated').click(function (e) {
    e.preventDefault();
    self.hideEditForm();
    self.$input.each(function () {
      $(this).val($(this).attr('data-initial-value'));
    });
  });
};

PrepopulatedInput.prototype.addDateMask = function () {
  var self = this;
  if (typeof self.$input === 'undefined' || !self.$input.data('date-mask')) {
    return;
  }
  self.$input.mask('00/00/0000');
};

PrepopulatedInput.prototype.showEditForm = function () {
  this.$prepopulatedText.slideUp(Bonkers.animationTime);
  this.$editForm.slideDown(Bonkers.animationTime);
  if (this.$wrapper.hasClass('prepopulated-address')) {
    this.$wrapper.find('.eircode__search').focus();
  } else {
    this.$input.focus();
  }
};

PrepopulatedInput.prototype.hideEditForm = function () {
  this.$editForm.slideUp(Bonkers.animationTime);
  this.$prepopulatedText.slideDown(Bonkers.animationTime);
};

$(document).ready(function () {
  var $inputFields = $('.prepopulated-address, .prepopulated_full_name, .prepopulated_string, .prepopulated_date, .prepopulated_select, .prepopulated_euro, .prepopulated_file');
  $.each($inputFields, function () {
    var ppInput = new PrepopulatedInput(this);
    ppInput.init();
  });
});
